// extracted by mini-css-extract-plugin
module.exports = {"BodyText":"BodyText-module--BodyText--1R5PJ","nolink":"BodyText-module--nolink--3l6cj"};